
export const hubspotEmailField = 'email';
export const hubspotFirstNameField = 'firstname';
export const hubspotLastNameField = 'lastname';
export const hubspotLastCompanyField = 'company';
export const hubspotModulesField = 'modules_of_interest';
